import requestData,{requestPostViaFormData} from "@/http/request";
import cookies from 'vue-cookies';
import { SUBMIT_TYPE_CODE_IN_QUOTE_PRICE } from '@/assets/result/part';
export function transferenceQuote({ aps_id, inquiry_id, }){
  return requestData('/apsapi/quoteprice/transferenceQuote','POST',{
    aps_id, 
    inquiry_id
  })
}
export function getTransferenceQuoteApsList({user_id,name,mobile,}){
  return requestData('/apsapi/quoteprice/getTransferenceQuoteApsList','POST',{
    user_id,
    name,
    mobile,
  })
}
export function quotePriceListApiRequest(obj) {
    obj = Object.entries(obj).filter(i=>i[1]!=null && String(i[1])).reduce((total,item)=>{
        total[item[0]] = item[1];
        return total;
    },{})
    return requestData('/apsapi/queryPrice/quotePriceListApi','POST',obj);
}
export function queryEnquiryInfoListOfRepairFactoryRequest(obj){
    if(!cookies.isKey('userInfo')) return Promise.reject({
        message:'获取登录身份失败，请重试',
    });
    const {logintype} = cookies.get('userInfo');
    let url = '';
    if(logintype==3 || logintype==2){
        url='/queryprice/queryenquiryinfolistApi';
    }
    else if(logintype==6){
        url='/jnqueryprice/queryenquiryinfolistApi';
    }
    else return Promise.reject({message:'未知的身份'});
    obj = Object.entries(obj).filter(i=>i[1]!=null && String(i[1])).reduce((total,item)=>{
        total[item[0]] = item[1];
        return total;
    },{})
    return requestData(url,'POST',obj);
}
export function copyEnquiryInfoAndFitsRequest(enquiryInfoId=0) {
    if(!enquiryInfoId) return Promise.reject({
        message:'询价单编号为空，请重试',
    });
    return requestData('/queryPrice/copyEnquiryInfoAndFits','POST',{
        enquiryInfoId,isnoBxgs:''
    });
}
export function deleteEnquiryInfoRequest(inquiry_id=0) {
    if(!inquiry_id) return Promise.reject({
        message:'询价单编号错误，请重试！',
    });
    return requestData('/jnqueryprice/deleteEnquiryInfo','POST',{inquiry_id});
}
export function cancelEnquiryRequest(enquiryId,enquiryNo) {
    const arr = [[!enquiryId,'询价单编号不能为空'],[!enquiryNo,'车架号不能为空']];
    const check = arr.find(i=>i[0]);
    if(check) return Promise.reject({
        message:check[1]
    });
    return requestData('/queryPrice/cancelEnquiry','POST',{enquiryId,enquiryNo});
}
export function createFormApiRequest({enquiryId,nbBxgsId='',isnoBxgs=''}){
    if(!cookies.isKey('userInfo')) return Promise.reject({
        message:'获取登录身份失败，请重试',
    });
    const {logintype} = cookies.get('userInfo');
    return new Promise((resolve,reject)=>{
        requestData(logintype==3?'/Xlcinquiry/detailApi':'/jninquiry/createFormApi','POST',{enquiryId, nbBxgsId, isnoBxgs}).then(r=>{
            if(r.status===200 && r.data.status==1 && logintype==3){
                if(r.data.data.oUser && r.data.data.oUser.f_manager_name){
                    r.data.data.tqsinfo.f_manager_name = r.data.data.oUser.f_manager_name
                }
                if(r.data.data.tipartlist) {
                    r.data.data.tipartList = r.data.data.tipartlist;
                    delete r.data.data.tipartlist;
                }
            }
            resolve(r);
        }).catch(r=>{
            console.trace(r);
            reject(r);
        });
    });
}

/**
 * 获取报价详情和放弃报价
 * @param enquiryInfoId
 * @param fqbz
 * @returns {Promise<never>|*}
 */
export function jnquotedetailApiRequest(enquiryInfoId=0,fqbz=null) {
    if(!enquiryInfoId) return Promise.reject({
        message:'单号错误，请重试',
    });
    const data = {};
    if(fqbz){
        data['fqbz']=fqbz;
        data['id']=enquiryInfoId;
    }
    else{
        data['enquiryInfoId']=enquiryInfoId;
    }
    return requestData('/apsapi/jnquote/jnquotedetailApi','POST',data);
}

/**
 * 报价完成和暂存
 * @param saveFlag
 * @param enquiryInfoId
 * @param signName
 * @param signPhone
 * @param ljmcArray
 * @param ljidArray
 * @param pjsycybArray
 * @param pjsycxxArray
 * @param pjsPtjArray
 * @param pjsPpjArray
 * @param pjsccjArray
 * @param pjsfcjArray
 * @param pjsYbjCsArray
 * @param pjsXxjCsArray
 * @param pjsPtjCsArray
 * @param pjsPpjCsArray
 * @param pjsCcjCsArray
 * @param pjsfcjCsArray
 * @param pjsycybBzArray
 * @param pjsycxxBzArray
 * @param pjsPtjBzArray
 * @param pjsPpjBzArray
 * @param pjsccjBzArray
 * @param pjsfcjBzArray
 * @param ycybQhFlagArray
 * @param ycxxQhFlagArray
 * @param ptQhFlagArray
 * @param ppQhFlagArray
 * @param ccQhFlagArray
 * @param fcQhFlagArray
 * @param enquiryFitsNum
 * @param isQhFlag
 * @param apsremark
 * @param freight
 * @param quoteEffectiveDay
 * @param standardYcljh
 * @param lastYbRate
 * @param lastPtXxRate
 * @param lastPpCcRate
 * @param lastFcRate
 * @returns {*}
 */
export function newQuotedPriceInfoAddApiRequest({
saveFlag=SUBMIT_TYPE_CODE_IN_QUOTE_PRICE.TEMPORARY_STORAGE,enquiryInfoId, signName, signPhone, ljmcArray,ljidArray,
pjsycybArray, pjsycxxArray, pjsPtjArray, pjsPpjArray, pjsccjArray, pjsfcjArray,
pjsYbjCsArray, pjsXxjCsArray, pjsPtjCsArray, pjsPpjCsArray, pjsCcjCsArray, pjsfcjCsArray,
pjsycybBzArray, pjsycxxBzArray, pjsPtjBzArray, pjsPpjBzArray, pjsccjBzArray, pjsfcjBzArray,
ycybQhFlagArray, ycxxQhFlagArray, ptQhFlagArray, ppQhFlagArray, ccQhFlagArray, fcQhFlagArray,
enquiryFitsNum, isQhFlag, apsremark, freight, quoteEffectiveDay, standardYcljh,
lastYbRate,lastPtXxRate,lastPpCcRate,lastFcRate
}) {

    const data = new FormData();
    data.append('saveFlag',saveFlag);
    if(enquiryInfoId){
        if(saveFlag===SUBMIT_TYPE_CODE_IN_QUOTE_PRICE.TEMPORARY_STORAGE){
            data.append('enquiryInfoId',enquiryInfoId?enquiryInfoId:'');
        }
        data.append('id',enquiryInfoId?enquiryInfoId:'');
    }
    if(saveFlag===SUBMIT_TYPE_CODE_IN_QUOTE_PRICE.DONE){
        data.append('lastYbRate',lastYbRate?lastYbRate:'');
        data.append('lastPtXxRate',lastPtXxRate?lastPtXxRate:'');
        data.append('lastPpCcRate',lastPpCcRate?lastPpCcRate:'');
        data.append('lastFcRate',lastFcRate?lastFcRate:'');
    }
    data.append('signName',signName?signName:'');
    data.append('signPhone',signPhone?signPhone:'');
    data.append('isQhFlag',isQhFlag?isQhFlag:'');
    data.append('apsremark',apsremark?apsremark:'');
    data.append('freight',freight?freight:'');
    data.append('quoteEffectiveDay',quoteEffectiveDay?quoteEffectiveDay:'');
    const format = {ljidArray,
        ljmcArray,pjsycybArray,pjsycxxArray,pjsPtjArray,pjsPpjArray,pjsccjArray,pjsfcjArray,
        pjsYbjCsArray, pjsXxjCsArray, pjsPtjCsArray, pjsPpjCsArray, pjsCcjCsArray, pjsfcjCsArray,
        pjsycybBzArray, pjsycxxBzArray, pjsPtjBzArray, pjsPpjBzArray, pjsccjBzArray, pjsfcjBzArray,
        ycybQhFlagArray, ycxxQhFlagArray, ptQhFlagArray, ppQhFlagArray, ccQhFlagArray, fcQhFlagArray,
        enquiryFitsNum,standardYcljh,editYcljhArray:standardYcljh,
    };
    Object.entries(format).forEach(item=>{
        item && item[1] && item[1].forEach(item2=>{
            data.append(item[0]+'[]',toString.call(item2)==='[object Number]'?item2:item2?item2:'');
        })
    });

    return requestPostViaFormData(saveFlag===SUBMIT_TYPE_CODE_IN_QUOTE_PRICE.DONE?'/apsapi/jnquote/jnquotedetailApi?saveFlag=xbwc':'/apsapi/Jnquote/newQuotedPriceInfoAddApi',data);
}

export function partBasicRequest({oe=''}){
    if(!oe) return Promise.reject({
        message:'零件号为空异常',
    });
    var d = new Date();
    var timeStamp = d.getTime();
    return requestData('/quoteprice/partbasic','POST',{
        oe,timeStamp,
    });
}

export function updateImgRequest({inquiry_id=''}){
    //console.log('updateImgRequest inquiry_id='+inquiry_id)
    if(!inquiry_id) return Promise.reject({
        message:'询价单号为空异常',
    });

    return requestData('/apsapi/Jnquote/updateImage','POST',{
        inquiry_id
    });
}

export function getPriceByOERequest({oe=''}) {
    if(!oe) return Promise.reject({
        message:'零件号为空异常',
    });
    return requestData('/appapi/quoteprice/getPriceByOE','POST',{OECode:oe});
}

export function getStandPartNameRequest({partName='', is_query = 0 }) {
    if(!partName) return Promise.reject({ message:'零件名不能为空' });
    return requestData('/searchprice/getStandPartName','GET',{
      partName,
      is_query,
    });
}

export function getOEcodeByStandardNameRequest({
    brandCode, autoGroupId,
    autoTypeId, partName, vin
}) {
    return requestData('/searchprice/getOEcodeByStandardName','GET',{
        brandCode,
        autoGroupId,
        autoTypeId,
        partName,
        vin
    });
}

export function batchquotepriceRequest({
    inquiryid=0,
    filename='',
    file,
}) {
    return requestData('/apsapi/quoteprice/batchquotepriceApi','POST',{
        inquiryid,filename,idFile:file
    });
}

export function updateValidateDateRequest({ validateDate, enquiryInfoId }){
    return requestData('/insapi/queryPrice/updateValidateDate','POST',{validateDate,enquiryInfoId});
}

export function shareQuotePriceRequest({enquiryId,fId}) {
    return requestData('/Appapi/twocode/getTwoCode','POST',{
        enquiryId,fId,
    });
}

export function pushInquiryRequest({inquiryId,aps}) {
    return requestData('/queryPrice/saveCpicBJResult','POST',{inquiryId,aps});
}

export function buildPriceRequest({enquiryInfoId}){
    return requestData('/apsapi/jnpjsquote/buildprice','POST',{enquiryInfoId});
}

/**
 * 
 * @param {*} districtLevel 同城1，省2，全国3
 * @returns 
 */
export function getCooperateQuotePersonRequest({districtLevel,tqsInfoId}){
    return requestData('/insapi/queryPrice/getCooperateQuotePerson','POST',{
        ['pjCszdbDTO.selectQuotePersonType']: districtLevel,
        ['pjCszdbDTO.ppId']: tqsInfoId,
    });
}
updateEnquiryDirectSupplyFlagRequest.PAY_TYPE_RESULT={
  ONLINE_PAY:3,
  OUTLINE_PAY:1,
}
export function updateEnquiryDirectSupplyFlagRequest({
    enquiryInfoId, directSupplyFlag, directSupplyRemark, xlcPhone, xlcName='', xkPhone, sumlossprice, xkName,
  address_id,
  pay_type,
    // sumFeeName, plateNo, sl, zp, kfp,
}) {
    return requestData('/queryPrice/updateEnquiryDirectSupplyFlag','POST',{
        enquiryInfoId, directSupplyFlag, directSupplyRemark, xlcPhone, xlcName, xkPhone, sumlossprice, xkName,
      address_id,
      pay_type,
        // sumFeeName, plateNo, sl, zp, kfp,
    });
}

export function queryEnquiryDirectSupplyListRequest({enquiryInfoId}){
    return requestData('/insapi/queryPrice/queryEnquiryDirectSupplyList','POST',{enquiryInfoId});
}

export function xjzSaveQueryPriceApiRequest(){
    const data = new FormData();
    data.append('dataJson',JSON.stringify(arguments[0]));
    return requestPostViaFormData('/queryPrice/xjzSaveQueryPriceApi',data);
}

export function isNoReturnRequest(enquiryPersonId){
    return requestData('/queryPrice/isnoReturn','POST',{
        id:enquiryPersonId
    });
}
export const getXlcNameByPhoneRequest = ({xlcPhone}) => requestData('/queryPrice/getXlcNameByPhone','POST',{xlcPhone})

export const OECorrectRequest = ({
  partId,
  preOE,
  newOE,
  reasonCode,
  reason,
  platformId,
  file,
}) => {
  const data = new FormData()
  Object.entries({
    partId,
    preOE,
    newOE,
    reasonCode,
    reason,
    platformId,
    file,
  }).forEach(item=>{
    data.append(item[0],item[1])
  })
  return requestPostViaFormData('/appapi/picc/correctOE',data)
}